var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = x({ ["camelCase"]: () => __WEBPACK_EXTERNAL_MODULE_camel_case_d7276c34__.camelCase });